export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12939.dc13ed5a.jpg";